module.exports = __webpack_public_path__ + "static/media/S33.b8559690.png";